module.exports = __webpack_public_path__ + "static/img/b28.b0ec391.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/b28.jpg
// module id = JPw6
// module chunks = 1